import axios from "axios";
import Links from "../constants/Links";

/**
 * API for managing per-programme document requirements and applicant submissions.
 */
const ProgrammeDocuments = {
  // 1. Applicant / shared requirement APIs

  listRequirementsForProgramme: async (programmeId) => {
    return axios.get(Links.programmeDocuments.requirementsByProgramme + programmeId);
  },

  getRequirement: async (id) => {
    return axios.get(Links.programmeDocuments.requirementById + id);
  },

  // 2. Management requirement APIs

  saveRequirement: async (data) => {
    return axios.post(Links.programmeDocuments.requirements, data);
  },

  deleteRequirement: async (id) => {
    return axios.delete(Links.programmeDocuments.requirementById + id);
  },

  // 3. Applicant submission APIs

  uploadSubmission: async (formData) => {
    return axios.post(Links.programmeDocuments.submissions, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },

  listMySubmissions: async () => {
    return axios.get(Links.programmeDocuments.mySubmissions);
  },

  getSubmission: async (id) => {
    return axios.get(Links.programmeDocuments.submissionById + id);
  },

  downloadSubmission: async (id) => {
    return axios.get(Links.programmeDocuments.submissionDownload + id + "/download/own", {
      responseType: "blob"
    });
  },

  deleteSubmission: async (id) => {
    return axios.delete(Links.programmeDocuments.submissionById + id);
  },

  // 4. Admin / screening submission APIs

  listSubmissionsForApplicant: async (applicantId) => {
    return axios.get(Links.programmeDocuments.submissionsByApplicant + applicantId);
  },

  downloadSubmissionAdmin: async (id) => {
    return axios.get(Links.programmeDocuments.submissionDownload + id + "/download", {
      responseType: "blob"
    });
  }
};

export default ProgrammeDocuments;
